export const loginPaths = ['/login/[[...id]]']
export const publicPaths = [...loginPaths, '/mcp/login']

const supplierPaths = ['/supplier-onboarding', ...publicPaths]
export const isSupplierPath = (pathname: string) =>
  pathname === '/' || supplierPaths.some((supplierPath) => pathname.startsWith(supplierPath))

const explicitSupplierPaths = ['/supplier-onboarding']
export const isExplicitSupplierPath = (pathname: string) =>
  explicitSupplierPaths.some((supplierPath) => pathname.startsWith(supplierPath))
